import {
  LocalDate31mqn6zavbpi8 as LocalDate,
  Companion_getInstance3h03aipe2gus4 as Companion_getInstance,
} from './LocalDate.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  numberToLong2pakxeg38estk as numberToLong,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  dividelr0uqtdj497z as divide,
  subtract2orl8z9upxd9l as subtract,
  modulooi4g1kq3dmtt as modulo,
  negate13xrbakfwasjy as negate,
  shiftRight2gqph14wydb8s as shiftRight,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { contains2c50nlxg7en7o as contains } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  safeMultiply1xb0xo3cufzd3 as safeMultiply,
  safeAdd2ojtf0puot5k0 as safeAdd,
} from './internal/mathNative.mjs';
import { DateTimeArithmeticException3b9ehoczpp1e2 as DateTimeArithmeticException } from './Exceptions.mjs';
import { Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance_0 } from './DateTimeUnit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_instance31uyudsfwogxj as Companion_instance,
  get_ISO_YEAR_MONTHnhzdbkah361r as get_ISO_YEAR_MONTH,
} from './format/YearMonthFormat.mjs';
import { YearMonthSerializer_getInstance1mubu03fd28xn as YearMonthSerializer_getInstance } from './serializers/YearMonthSerializers.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  Monthisypd6pyawk7 as Month,
  get_number11nqnpf0wxtuc as get_number,
} from './Month.mjs';
import {
  isLeapYear2i238jn7muq0f as isLeapYear,
  monthLength2df23yfyn71oo as monthLength,
} from './internal/dateCalculations.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { compareValuesBy2ycqeh37x2wfm as compareValuesBy } from '../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function onDay(_this__u8e3s4, day) {
  return LocalDate().new_kotlinx_datetime_LocalDate_rqj1zf_k$(_this__u8e3s4.year_1, _this__u8e3s4.get_month_ivc8d3_k$(), day);
}
function plus(_this__u8e3s4, value, unit) {
  return plus_0(_this__u8e3s4, fromInt(value), unit);
}
function minus(_this__u8e3s4, value, unit) {
  return minus_0(_this__u8e3s4, fromInt(value), unit);
}
function get_prolepticMonth(_this__u8e3s4) {
  var tmp0 = multiply(numberToLong(_this__u8e3s4.year_1), 12n);
  // Inline function 'kotlin.Long.plus' call
  var other = _this__u8e3s4.monthNumber_1 - 1 | 0;
  return add(tmp0, fromInt(other));
}
function fromProlepticMonth(_this__u8e3s4, prolepticMonth) {
  // Inline function 'kotlin.floorDiv' call
  // Inline function 'kotlin.floorDiv' call
  var other = fromInt(12);
  var q = divide(prolepticMonth, other);
  if ((prolepticMonth ^ other) < 0n && !(multiply(q, other) === prolepticMonth)) {
    var _unary__edvuaz = q;
    q = subtract(_unary__edvuaz, get_ONE());
  }
  var year = q;
  // Inline function 'kotlin.ranges.contains' call
  var this_0 = numberRangeToNumber(Companion_getInstance().MIN_1.year_1, Companion_getInstance().MAX_1.year_1);
  // Inline function 'kotlin.require' call
  if (!contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), year)) {
    var message = 'Year ' + year.toString() + ' is out of range: ' + Companion_getInstance().MIN_1.year_1 + '..' + Companion_getInstance().MAX_1.year_1;
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  // Inline function 'kotlin.mod' call
  // Inline function 'kotlin.mod' call
  var other_0 = fromInt(12);
  var r = modulo(prolepticMonth, other_0);
  var tmp$ret$6 = add(r, other_0 & shiftRight((r ^ other_0) & (r | negate(r)), 63));
  var month = convertToInt(tmp$ret$6) + 1 | 0;
  return YearMonth().new_kotlinx_datetime_YearMonth_rc8qre_k$(convertToInt(year), month);
}
function get_yearMonth(_this__u8e3s4) {
  return YearMonth().new_kotlinx_datetime_YearMonth_rn1bif_k$(_this__u8e3s4.year_1, _this__u8e3s4.get_month_ivc8d3_k$());
}
function plus_0(_this__u8e3s4, value, unit) {
  var tmp;
  try {
    // Inline function 'kotlin.let' call
    var monthsToAdd = safeMultiply(value, fromInt(unit.months_1));
    var tmp_0;
    if (monthsToAdd === 0n) {
      tmp_0 = _this__u8e3s4;
    } else {
      tmp_0 = fromProlepticMonth(Companion_instance_0, safeAdd(get_prolepticMonth(_this__u8e3s4), monthsToAdd));
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof ArithmeticException()) {
      var e = $p;
      throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Arithmetic overflow when adding ' + value.toString() + ' of ' + unit.toString() + ' to ' + _this__u8e3s4.toString(), e);
    } else {
      if ($p instanceof IllegalArgumentException()) {
        var e_0 = $p;
        throw DateTimeArithmeticException().new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$('Boundaries of YearMonth exceeded when adding ' + value.toString() + ' of ' + unit.toString() + ' to ' + _this__u8e3s4.toString(), e_0);
      } else {
        throw $p;
      }
    }
  }
  return tmp;
}
function minus_0(_this__u8e3s4, value, unit) {
  return !(value === -9223372036854775808n) ? plus_0(_this__u8e3s4, negate(value), unit) : plus(plus_0(_this__u8e3s4, 9223372036854775807n, unit), 1, unit);
}
function format(_this__u8e3s4, format) {
  return format.format_l1mq08_k$(_this__u8e3s4);
}
function minusMonth(_this__u8e3s4) {
  return minus(_this__u8e3s4, 1, Companion_getInstance_0().MONTH_1);
}
function validateYear($this) {
  var containsArg = $this.year_1;
  // Inline function 'kotlin.require' call
  if (!(-999999999 <= containsArg ? containsArg <= 999999999 : false)) {
    var message = 'Year ' + $this.year_1 + ' is out of range: -999999999..999999999';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      parse_ziaw5h_k$(input, format) {
        return format.parse_xovy9i_k$(input);
      }
      parse$default_epr5sf_k$(input, format, $super) {
        format = format === VOID ? Formats_instance.get_ISO_18jrwk_k$() : format;
        return $super === VOID ? this.parse_ziaw5h_k$(input, format) : $super.parse_ziaw5h_k$.call(this, input, format);
      }
      Format_1myt4u_k$(block) {
        return Companion_instance.build_xjwtmz_k$(block);
      }
      serializer_9w0wvi_k$() {
        return YearMonthSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      get_ISO_18jrwk_k$() {
        return get_ISO_YEAR_MONTH();
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  return Formats_instance;
}
function YearMonth$_get_year_$ref_chp4n6() {
  return constructCallableReference((p0) => p0.year_1, 1, 0, 72);
}
function YearMonth$_get_month_$ref_9rphhd() {
  return constructCallableReference((p0) => p0.get_month_ivc8d3_k$(), 1, 0, 73);
}
var YearMonthClass;
function YearMonth() {
  if (YearMonthClass === VOID) {
    class $ {
      constructor(year, month, unit) {
        return new.target.new_kotlinx_datetime_YearMonth_idwmju_k$(year, month, unit);
      }
      static new_kotlinx_datetime_YearMonth_idwmju_k$(year, month, unit) {
        var $this = createThis(this);
        $this.year_1 = year;
        $this.monthNumber_1 = month;
        return $this;
      }
      get_month_ivc8d3_k$() {
        return Month(this.monthNumber_1);
      }
      get_firstDay_u4rr11_k$() {
        return onDay(this, 1);
      }
      get_lastDay_hikhp_k$() {
        return onDay(this, this.get_numberOfDays_jvae9s_k$());
      }
      get_numberOfDays_jvae9s_k$() {
        return monthLength(this.monthNumber_1, isLeapYear(this.year_1));
      }
      static new_kotlinx_datetime_YearMonth_rc8qre_k$(year, month) {
        var $this = this.new_kotlinx_datetime_YearMonth_idwmju_k$(year, month, Unit_instance);
        var containsArg = $this.monthNumber_1;
        // Inline function 'kotlin.require' call
        if (!(1 <= containsArg ? containsArg <= 12 : false)) {
          var message = 'Month must be in 1..12, but was ' + month;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        validateYear($this);
        return $this;
      }
      static new_kotlinx_datetime_YearMonth_rn1bif_k$(year, month) {
        var $this = this.new_kotlinx_datetime_YearMonth_idwmju_k$(year, get_number(month), Unit_instance);
        validateYear($this);
        return $this;
      }
      compareTo_zex1lo_k$(other) {
        var tmp = KProperty1();
        var tmp_0 = getPropertyCallableRef('year', 1, tmp, YearMonth$_get_year_$ref_chp4n6(), null);
        var tmp_1 = KProperty1();
        return compareValuesBy(this, other, [tmp_0, getPropertyCallableRef('month', 1, tmp_1, YearMonth$_get_month_$ref_9rphhd(), null)]);
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_zex1lo_k$(other instanceof YearMonth() ? other : THROW_CCE());
      }
      toString() {
        return Formats_instance.get_ISO_18jrwk_k$().format_l1mq08_k$(this);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof YearMonth()) {
          tmp_0 = this.year_1 === other.year_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.get_month_ivc8d3_k$().equals(other.get_month_ivc8d3_k$());
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(this.year_1, 31) + this.get_month_ivc8d3_k$().hashCode() | 0;
      }
    }
    initMetadataForClass($, 'YearMonth', VOID, VOID, [Comparable()], VOID, VOID, {0: YearMonthSerializer_getInstance});
    YearMonthClass = $;
  }
  return YearMonthClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
Formats_instance = new (Formats())();
//endregion
//region block: exports
export {
  Companion_instance_0 as Companion_instance3t7kgujds2u7a,
  YearMonth as YearMonth22nahmknr467s,
  format as format2qj76aukcztvp,
  minusMonth as minusMonth2kfh16ajztknk,
  minus as minusrtzvftl23j9y,
  plus as plus31cnlckpy77fa,
  get_yearMonth as get_yearMonth3uo9i62rhbu6p,
};
//endregion

//# sourceMappingURL=YearMonth.mjs.map
